<template>
    <el-form ref="form" label-width="150px" :model="form" size="small" :rules="rules">
        <div style="width:1000px; padding:20px 450px; margin-bottom:10px;">
            <b style="font-size:18px">Sale Leads</b>
        </div>
        <div style="width:1000px;">
            <el-form-item label="Company Name" prop="CompanyName">
                <el-input v-model="form.CompanyName"></el-input>
            </el-form-item>

            <el-form-item label="Country" prop="Country">
                <el-input v-model="form.Country"></el-input>
            </el-form-item>

            <el-form-item label="Contact Info" prop="ContactInfo">
                <el-input v-model="form.ContactInfo"></el-input>
            </el-form-item>

            <el-form-item label="Note from Sales">
                <el-input v-model="form.NotefromSales"></el-input>
            </el-form-item>

            <el-form-item label="Expect Time" prop="ExpectTime">
                <el-date-picker
                    :picker-options="pickerOptions"
                    v-model="form.ExpectTime"
                    type="date">
                </el-date-picker>
            </el-form-item>
            
            <el-form-item label="Partner" prop="Partner">
            <el-select v-model="form.Partner" placeholder="">
                <el-option
                    v-for="item in partnerList"
                    :key="item.ID"
                    :label="item.CompanyName"
                    :value="item.ID">
                </el-option>
            </el-select>
            </el-form-item>

            <el-form-item  label="Status">
            <el-select v-model="form.Status" placeholder="" :disabled="true">
                <el-option
                    v-for="item in statusList"
                    :key="item.ID"
                    :label="item.Name"
                    :value="item.ID">
                </el-option>
            </el-select>
            </el-form-item>

            <el-form-item label="Process Result">
                <el-input v-model="form.Result" :disabled="true"></el-input>
            </el-form-item>
        </div>

  <div id="description" style="width:1000px; height:280px; padding-left:10px;">Description</div> 
          
     <br><br><br>
        <div style="padding-left:915px; padding-top:50px; float:left;">
       <el-button class="submit" type="primary" @click="submit">Submit</el-button>
        </div>
    </el-form>
</template>

<script>
import { formatDate } from "@/methods/date.js";
import { orderStatusList } from "@/components/SaleLeads/data.js";
export default {
    props:{
        id:{}
    },
    data () {
        return {
            editor:"",
            form:{
                CompanyName:"",
                Country:"",
                ContactInfo:"",
                NotefromSales:"",
                ExpectTime:"",
                Partner:"",
                Status:"0",
                Result:""
            },
            statusList:orderStatusList,
            rules:{
                CompanyName:[{ required: true, message: 'Please enter your company name', trigger: 'blur' }],
                Country:[{ required: true, message: 'Please enter your country', trigger: 'blur' }],
                ContactInfo:[{ required: true, message: 'Please enter your contact info', trigger: 'blur' }],
                ExpectTime:[{type: 'date', required: true, message: 'Please select the time', trigger: 'change'}],
                Partner:[{ required: true, message: 'Please select a partner', trigger: 'blur' }]
            },
            partnerList:[],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() < Date.now() - 8.64e7;   //禁用以前的日期，今天不禁用
                }
            }
        };
    },
    mounted () {
        let E = window.wangEditor;
        this.editor = new E('#description');
        this.editor.customConfig.zIndex = 100;
        // 上传图片到服务器，base64形式
        this.editor.customConfig.uploadImgShowBase64 = true;
        this.editor.customConfig.uploadFileServer = `${this.$http.host}partnerManageServer/uploadFileSaleLeads`;
        this.editor.customConfig.downloadFileServer = `${this.$http.host}akuvoxwiki/download/partnerManage/saleLeads`;
        // 创建一个富文本编辑器
        this.editor.create();

        this.$http.get("getAllPartner",{},(data)=>{
            this.partnerList = data.data;
        });
    },
    created () {
        if(this.id)
            this.$http.get("getSaleLeadsInfo",{
                ID:this.id
            },(data)=>{
                data = data.data;
                this.form.ExpectTime = new Date(data.ExpectTime);
                this.form.CompanyName = data.CompanyName;
                this.form.Country = data.Country;
                this.form.ContactInfo = data.ContactInfo;
                this.form.NotefromSales = data.NotefromSales;
                this.form.Partner = data.Partner;
                this.form.Status = data.Status;
                this.form.Result = data.Result;
                this.editor.txt.html(data.Description);
            });
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let methods = !this.id ? 'post' : 'put';
                let url = !this.id ? 'addSaleLeads' : 'editSaleLeads';

                this.$http[methods](url,{
                    ID:this.id,
                    CompanyName:this.form.CompanyName,
                    Country:this.form.Country,
                    Partner:this.form.Partner,
                    Status:this.form.Status,
                    Result:this.form.Result,
                    ContactInfo:this.form.ContactInfo,
                    NotefromSales:this.form.NotefromSales,
                    ExpectTime:formatDate(this.form.ExpectTime),
                    Description:this.editor.txt.html()
                },(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$router.push("/saleLeads");
                });
            });
        }
    }
};
</script>

